import bem from 'utils/bem';

export const block = bem('edit-captions-modal');

export const getMaxChars = (textRange: [number, number]): number => {
  const charsAmount = textRange[1] - textRange[0];

  return charsAmount > 0 ? charsAmount : 0;
};
